export default "__VITE_ASSET__DOmiso5h__"